<template>
    <component
        :is="component"
        class="PartnersBlockItem flex items-center justify-center px-4 py-8"
        :class="{ 'hover:border-gray-100 hover:dark:border-default hover:shadow-xl': isNuxtLink || isLink }"
        v-bind="$attrs"
    >
        <slot v-if="$slots.default" />
        <img v-else :alt="props.alt" :height="props.height" loading="lazy" :src="props.imageSrc" :width="props.width" />
    </component>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { computed } from 'vue'

const props = defineProps({
    imageSrc: {
        type: String,
        default: undefined
    },
    width: {
        type: Number,
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    alt: {
        type: String,
        default: undefined
    }
})

const attrs = useAttrs() as { to?: string; href?: string }

const isNuxtLink = computed(() => Boolean(attrs.to))
const isLink = computed(() => Boolean(attrs.href))
const component = computed(() => {
    if (isNuxtLink.value) {
        return 'NuxtLink'
    }
    if (isLink.value) {
        return 'a'
    }
    return 'div'
})
</script>
